<template>
  <div class="one"> 
    <div v-for="row in rows" :key="row" class="labelbody">
      <p class="text-center font-weight-bold"><i>Institute of the Industrial Ecology Problems of the North, Kola Science Centre, Russian Academy of Sciences (INEP)</i></p>

<br>
      <div>
        <div class="text-center font-weight-bold"><i>{{row.store}}</i></div>
      </div>

      <div class="d-flex flex-wrap">
        <!-- <span v-if="row.reserve">{{row.reserve}}.&nbsp;</span>
        <span v-if="row.country">{{row.country}}.&nbsp;</span>
        <span v-if="row.province">{{row.province}}.&nbsp;</span> -->
        <span v-if="row.location">{{row.location}}. </span>
      </div>

      <div class="d-flex flex-wrap">
        <span><point-widget v-bind="{mode:'view'}" v-model="row.coordinates"/></span> <span v-if="row.alt">. El.: {{row.alt}} m a.s.l. </span> 
      </div>


      <div class="d-flex flex-wrap">
        Leg.:&nbsp<date-widget v-bind="{mode:'view'}" v-model="row.legdate" />&nbsp{{row.legname2}}&nbsp<br>
      </div>
      <div class="d-flex flex-wrap" v-if = "row.species.rows[0] !== undefined">
        Det.:&nbsp<date-widget v-bind="{mode:'view'}" v-model="row.species.rows[0].detdate" />&nbsp{{row.species.rows[0].detname2}}&nbsp<br>
      </div>
      <span v-if="row.legnum"> Field №: {{row.legnum}} </span> <span class="text-right" v-if="row.localcollnumber">{{row.mainstorage.name}}&nbsp{{row.localcollnumber}}</span>
      <div class="text-right"><i>Флористический район по Раменской (1983):&nbsp{{ row.biodistrict }}</i></div>
      <!-- <div class="text-right">LID: {{row.linkid}}</div> -->
      <div>- - - - - - - ✂ - - - - - - - </div>
      <p>&nbsp;</p>
    </div>
  </div>
</template>
<!--
<div class="text-right">{{row.mainstorage.name}} {{row.localcollnumber}}</div><br>


-->

<script>
import PointWidget from '@/components/widgets/PointWidget.vue';
import DateWidget from '@/components/widgets/DateWidget.vue';
export default {
  name: 'inep-vascular-print-page',
  components: {
    PointWidget,
    DateWidget,

  },
  props:['meta', 'rows'],
  data(){ 
    return {

    }
  },
  methods: {

  },

}
</script>

<style scoped>
@media print {
  .two {
    column-count: 2;
    gap: 1cm;
    column-rule: 1px dotted #666;
    font-family:'Times New Roman';
    font-size: 10px;
  }
  .one {
    column-count: 1;
    -webkit-column-count: 1;
    -moz-column-count: 1;
    font-family:'Times New Roman';
    font-size: 10px;

  }
  @page {
    margin: 0.5cm;
  }
  .labelbody {
    page-break-inside: avoid;
  }
}
</style>
<!--    width: 12cm;-->